module.exports = __webpack_public_path__ + "static/media/credit-card-black-green.d33c9be6.svg";